import React, { useEffect, useState, useContext } from 'react'
import { Form, Button, List, Sidebar, Menu } from 'semantic-ui-react'
import { Loader, Dimmer } from 'semantic-ui-react'
import AnalyticsUserMapping from '../AnalyticsUserMapping'
import TapeChart from '../TapeChart'
import './style.css'
import qs from 'querystringify'
import MainMenu from '../../components/MainMenu'
import RestrictionsPopup from '../../components/RestrictionsPopup'
import CustomerDropDown from '../../components/shared/CustomerDropDown'
import EntityTypesDropDown from '../../components/shared/EntityTypesDropDown'
import DynamicEntityDropDown from '../../components/shared/DynamicEntityDropDown'
import TagsDropDown from '../../components/shared/TagsDropDown'
import HotelsDropDown from '../../components/shared/HotelsDropDown'
import GuestSearchDropDown from '../../components/shared/GuestSearchDropDown'
import ProductsDropDown from '../../components/shared/ProductsDropDown'
import ReservationSourcesDropDown from '../../components/shared/ReservationSourcesDropDown'
import PaymentArrangementsDropDown from '../../components/shared/PaymentArrangementsDropDown'
import MarketSegmentsDropDown from '../../components/shared/MarketSegmentsDropDown';
import ReservationStatusesDropDown from '../../components/shared/ReservationStatusesDropDown'
import RatesDropDown from '../../components/shared/RatesDropDown'
import ReservationTypesDropDown from '../../components/shared/ReservationTypesDropDown'
import MaintenanceReport from '../../components/Reports/Maintenance'
import CustomerChannelMapping from '../../components/CustomerChannelMapping'
import RoomTypesDropDown from '../../components/shared/RoomTypesDropDown'
import NationalitiesDropDown from '../../components/shared/NationalitiesDropDown'
import LanguagesDropDown from '../../components/shared/LanguagesDropDown'
import GroupReservation from '../GroupReservation'
import CumulativeDetailedIncomeReport from '../../components/Reports/CumulativeDetailedIncomeReport'
import PriceUpdatePopup from '../../components/PriceUpdatePopup'
import YieldPopup from "../../components/YieldPopup"
import AddonsByReservationReport from '../../components/Reports/AddonsByReservation'
import AddonsCommissionsReport from '../../components/Reports/AddonsCommissions'
import PyramidReportsTabs from '../PyramidReportsTabs';
import { SemanticToastContainer } from 'react-semantic-toasts'
import { TimePicker } from '../../components/shared/DatePicker'
import ApartmentOwnersPortal from '../ApartmentOwnersPortal'
import CurrencyInput from '../../components/shared/CurrencyInput';
import NumericInput from '../../components/shared/NumericInput';
import RestrictionTypesDropDown from '../../components/shared/RestrictionTypesDropDown'
import ArrivalListReport from '../../components/Reports/ArrivalList'
import FolioPage from '../Folio'
import ImportExcelPage from '../ImportExcel'
import ReservationPage from '../Reservation'
import PageHeader from '../../components/PageHeader'
import DetailedCashReport from '../../components/Reports/DetailedCash'
import { MenuActions } from '../../components/shared/constants'
import ColorPicker from '../../components/shared/ColorPicker'
import BankDeposit from '../BankDeposit'
import ReservationSearch from '../Reservation/search'
import ReceiptPopup from '../../components/ReceiptPopup'
import { HomePage } from '../Home'
import { DashBoard } from '../DashBoard'
import Tags from '../Tags'
import OccupancyForecastReport from '../../components/Reports/DaysForecast/OccupancyForecast'
import AddonsForecastReport from '../../components/Reports/DaysForecast/AddonsForecast'
import GuestsForecastReport from '../../components/Reports/DaysForecast/GuestsForecast'
import RoomsForecastReport from '../../components/Reports/DaysForecast/RoomsForecast'
import ApplicationContext from '../../context'
import CancelReservationsReport from '../../components/Reports/CancelReservations'
import { EmailSettings } from '../EmailSettings'
import Reports from '../../components/Reports'
import { GuestReport } from '../../components/Reports/Guest'
import { LivePage } from '../Live'
import InvoicesReceiptsReport from '../../components/Reports/InvoicesReceipts'
import { RMSRulesPage } from '../RMSRules'
import { FamilyAndFriendsPage } from '../FamilyAndFriends'
import { ExpensesManagementPage } from '../Expenses'
import { ApartmentOwnerReport } from "../../components/Reports/ApartmentOwner";
import {DocumentSeriesPage} from '../DocumentSeries'
import AccountingSystemReport from '../../components/Reports/AccountingSystem';
import { CustomerIncomeReport } from '../../components/Reports/CustomerIncome';
import { HotelCurrencyPage } from '../HotelCurrency'
import { LoginPage } from '../Login'
import {AccountingSystemMappingPage} from '../AccountingSystemMappingPage'
import ReceptionAnywhere from "../ReceptionAnywhere"
import ArrivalsAndGuestInHouseSearch from '../../components/ArrivalsAndGIHSearch'
import HousekeepingReport from '../../components/Reports/HouseKeeping'
import PendingFoliosReport from '../../components/Reports/PendingFolios'
import AvailabilityPage from '../Availability'
import {useTextResources} from '../../language'

let HotelID = 5567
const params = qs.parse(window.location.search)
if (params.hotelId) {
    HotelID = Number(params.hotelId)
}
if (params.hotelid) {
    HotelID = Number(params.hotelid)
}

/* eslint-disable react/display-name */
let pages = [
    {
        title: 'Cancel Reservations Report',
        element: () => <CancelReservationsReport />
    },
    {
        title: "Popups",
        element: () => {
            return <List horizontal>
                <List.Item>
                    <RestrictionsPopup controller="RestrictionsController" HotelID={HotelID} />
                    <Button onClick={() => {
                        window["RestrictionsController"]("open")
                    }}>Restrictions Popup</Button>
                </List.Item>
                <List.Item>
                    <PriceUpdatePopup controller="PriceUpdatePopup" HotelID={HotelID} />
                    <Button onClick={() => {
                        window["PriceUpdatePopup"]("open")
                    }}>Price Update Popup</Button>
                </List.Item>
                <List.Item>
                    <CustomerChannelMapping />
                </List.Item>
                <List.Item>
                    <YieldPopup controller="YieldPopup" HotelId={HotelID} />
                    <Button onClick={() => {
                        window["YieldPopup"]("open")
                    }}>Yield Popup</Button>
                </List.Item>
                <List.Item>
                    <ReceiptPopup controller="ReceiptPopup" reservation={{
                        HotelId: 5026,
                        Id: 98759,
                        CurrencyId: 1
                    }} />
                    <Button onClick={() => {
                        window["ReceiptPopup"]("open")
                    }}>Receipt Popup</Button>
                </List.Item>
            </List>
        }
    },
    {
        title: "Calendar",
        element: () => <TapeChart />
    },
    {
        title: "Analytics User Mapping",
        element: () => <AnalyticsUserMapping />
    },
    {
        title: "Form Controls",
        element: () => {
            return <Form>
                <Form.Group widths="6">
                    <Form.Field control={CustomerDropDown} label="Customer dropdown" />
                    <Form.Field control={HotelsDropDown} label="Hotels dropdown" />
                    <Form.Field control={GuestSearchDropDown} label="Guest search dropdown" />
                    <Form.Field control={ProductsDropDown} HotelID={HotelID} label="Products dropdown" />
                    <Form.Field control={ReservationSourcesDropDown} label="Reservation Sources" />
                    <Form.Field control={PaymentArrangementsDropDown} label="Payment Arrangements" />
                </Form.Group>
                <Form.Group widths="6">
                    <Form.Field control={MarketSegmentsDropDown} label="Market Segments" />
                    <Form.Field control={ReservationStatusesDropDown} label="Reservation Statuses" />
                    <Form.Field control={RatesDropDown} HotelID={HotelID} label="Rates" />
                    <Form.Field control={ReservationTypesDropDown} multiple label="Reservation Types" />
                    <Form.Field control={RoomTypesDropDown} multiple label="Roomtypes Types" />
                    <Form.Field control={NationalitiesDropDown} label="Nationality"></Form.Field>
                </Form.Group>
                <Form.Group widths="6">
                    <Form.Field control={LanguagesDropDown} label="Language"></Form.Field>
                    <Form.Field control={TimePicker} label="Time Picker"></Form.Field>
                    <Form.Field control={CurrencyInput} currency="%" label="Curency Input"></Form.Field>
                    <Form.Field control={NumericInput} digits={2} label="Numeric1" min={0} max={10}></Form.Field>
                    <Form.Field control={NumericInput} digits={2} buttonPlacement="right" label="Numeric1" min={0} max={10}></Form.Field>
                    <Form.Field control={RestrictionTypesDropDown} label="Restriction types"></Form.Field>
                </Form.Group>
                <Form.Group widths="6">
                    <Form.Field control={ColorPicker} label="Color Picker"></Form.Field>
                    <Form.Field control={EntityTypesDropDown} entityIds={[6,12]} label="Entity Types DropDown" />
                    <Form.Field control={DynamicEntityDropDown} entityTypeId={12} label="Dynamic Entity DropDown - Room Types" />
                    <Form.Field control={DynamicEntityDropDown} entityTypeId={6} label="Dynamic Entity DropDown - Rooms" />
                    <Form.Field control={TagsDropDown} label="Tags DropDown" />
                </Form.Group>
            </Form>
        }
    },
    {
        title: 'Maintenance Report',
        element: () => <MaintenanceReport />

    },
    {
        title: 'Pyramid Reports',
        element: () => <PyramidReportsTabs />

    },
    {
        title: 'Group Reservation',
        element: () => <GroupReservation HotelID={HotelID} />

    },
    {
        title: '811 Report',
        element: () => <CumulativeDetailedIncomeReport HotelID={HotelID} />

    },
    {
        title: 'ApartmentOwners',
        element: () => <ApartmentOwnersPortal HotelID={HotelID} />

    },
    {
        title: 'BankDeposits',
        element: () => <BankDeposit />

    },
    {
        title: 'AddonsByReservationReport',
        element: () => <AddonsByReservationReport />

    },
    {
        title: 'AddonsCommissionsReport',
        element: () => <AddonsCommissionsReport />

    },
    {
        title: 'ArrivalListReport',
        element: () => <ArrivalListReport />

    },
    {
        title: 'Folio',
        element: () => <FolioPage />

    }
    ,
    {
        title: 'Import Excel',
        element: () => <ImportExcelPage HotelId={HotelID} />

    },
    {
        title: 'Full Reservation',
        element: () => <ReservationPage reservationId={122303} />

    }, {
        title: 'Detailed Cash report',
        element: () => <DetailedCashReport HotelID={HotelID} />

    }, {
        title: 'Reservation Search',
        element: () => <ReservationSearch/>
    }, {
        title: 'DashBoard',
        element: () => <DashBoard />
    },{
        title: 'ApartmentOwnerReport',
        element: () => <ApartmentOwnerReport />
    },{
        title: 'CustomerIncomeReport',
        element: () => <CustomerIncomeReport />
    }, {
        title: 'Home Page',
        element: () => <HomePage HotelID={HotelID} />
    },
    {
        title: 'Occupancy Forecast Report',
        element: () => <OccupancyForecastReport HotelID={HotelID} />
    },
    {
        title: 'Addons Forecast Report',
        element: () => <AddonsForecastReport />
    },
    {
        title: 'Guests Forecast Report',
        element: () => <GuestsForecastReport />
    },
    {
        title: 'Rooms Forecast Report',
        element: () => <RoomsForecastReport />
    },
    {
        title: 'Email Settings',
        element: () => <EmailSettings />
    },
    {
        title: 'Reports',
        element: () => <Reports />
    },
    {
        title: 'Guest Report',
        element: () => <GuestReport />
    },
    {
        title: 'Live',
        element: () => <LivePage />
    },
    {
        title: 'Tags',
        element: () => <Tags />
    },
    {
        title: 'Invoices Receipts Report',
        element: () => <InvoicesReceiptsReport />
    },
    {
        title: 'Pending Folios Report',
        element: () => <PendingFoliosReport />        
    },
    {
        title: 'RMS Rules Page',
        element: () => <RMSRulesPage />
    },
    {
        title: 'Family And Friends Page ',
        element: () => < FamilyAndFriendsPage/>
    },
    {
        title: 'Expenses Management Page',
        element: () => <ExpensesManagementPage />
    },
    {
        title: 'Reception Anywhere',
        element: () => <ReceptionAnywhere HotelId={HotelID} />
    },
    {
        title: 'Document Series Page',
        element: () => <DocumentSeriesPage />
    },
    {
        title: 'Accounting System Report',
        element: () => <AccountingSystemReport />
    },
    {
        title: 'Accounting System Mapping Page',
        element: () => <AccountingSystemMappingPage />
    },
    {
        title: 'Hotel Currency',
        element: () => <HotelCurrencyPage />
    }, {
        title: 'Login',
        element: () => <LoginPage />
    },
    {
        title: 'Accounting System Mapping Page',
        element: () => <AccountingSystemMappingPage />
    },
    {
        title: 'Arrivals New',
        element: () => < ArrivalsAndGuestInHouseSearch HotelId={window.optima?.user?.CurrentHotel?.Id} />

    },
    {
        title: 'Guest In House New',
        element: () => < ArrivalsAndGuestInHouseSearch IsGuestInHouse={true} HotelId={window.optima?.user?.CurrentHotel?.Id} />

    },
    {
        title: 'HouseKeeping Report',
        element: () => < HousekeepingReport />

    },
    {
        title: 'Availability',
        element: () => < AvailabilityPage />
    }
]

pages = pages.map((x, index)=>{
    return {
        title: x.title,
        element: x.element,
        key: index
    }
})

/* eslint-enable react/display-name */
const StoryBoard = () => {
    const [visible, setVisible] = useState(false)
    const { state } = useContext(ApplicationContext)
    const [active, setActive] = useState(localStorage.getItem("O2R_SBActive") || 0)
    const [filter, setFilter] = useState()
    const text = useTextResources()

    useEffect(() => {
        window.optima.commands.unsubscribe(MenuActions.toggle)
        window.optima.commands.subscribe(MenuActions.toggle, () => {
            setVisible(!visible)
        })
    }, [visible])

    const onSearchChange = (e, { value }) => {
        setFilter(value)
    }

    useEffect(() => {
        localStorage.setItem("O2R_SBActive", active)
    }, [active])
    const filtered = filter ? pages.filter(x => x.title.toLowerCase().includes(filter.toLowerCase())) : pages
    return (
        <>
            <div id="menu"><MainMenu HotelId={HotelID} /></div>
            <PageHeader title={text(pages[active].title)} subtitle="Sub title here" style={{ marginBottom: 0 }} />
            <Sidebar.Pushable style={{ display: "flex" }}>
                <Sidebar
                    as={Menu}
                    animation='overlay'
                    inverted
                    onHide={() => setVisible(false)}
                    vertical
                    visible={visible}
                    width='wide'
                    activeIndex={active}
                >
                    <Menu.Item>
                        <Form.Input fluid className='icon' icon='search' placeholder='Search...' onChange={onSearchChange} />
                    </Menu.Item>
                    {
                        filtered.map(page => {
                            return <Menu.Item as='a' key={page.key} onClick={() => setActive(page.key)}>
                                {page.title}
                            </Menu.Item>
                        })
                    }
                </Sidebar>
                <Sidebar.Pusher style={{ padding: "0.5em", flex: 1, display: "flex", flexDirection: "column" }}>
                    {
                        pages[active].element()
                    }
                </Sidebar.Pusher>
            </Sidebar.Pushable>
            {/* <Tab id="timelinetabs" defaultActiveIndex={active} menu={{ fluid: true, vertical: true }} panes={panes} grid={{ paneWidth: 13, tabWidth: 3 }} /> */}
            <SemanticToastContainer />
            <Dimmer style={{ zIndex: 110000 }} active={state.loader}>
                <Loader size="huge">Loading</Loader>
            </Dimmer>
        </>
    )
}

export default StoryBoard